import { render } from "./StudentsList.vue?vue&type=template&id=23a8b8d4&scoped=true"
import script from "./StudentsList.vue?vue&type=script&lang=js"
export * from "./StudentsList.vue?vue&type=script&lang=js"

import "./StudentsList.vue?vue&type=style&index=0&id=23a8b8d4&scoped=true&lang=css"

import exportComponent from "/Users/habeebrahman/Documents/htdocs/cdz_projects/wg-frontend-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a8b8d4"]])

export default __exports__